import React from "react"

import {
  Wrapper,
  TitleWrapper,
  IconWrapper,
  InfoIcon,
  Tooltip,
  TooltipText,
  DesktopAd,
} from "./styles"

const RightRailContentfulAd = ({ element }) => (
  <Wrapper className="right-rail-contentful-ad">
    <TitleWrapper>
      <h5>Advertisement</h5>
      <IconWrapper tabIndex={0}>
        <InfoIcon id="info-icon" height="19px" width="19px" />
      </IconWrapper>
      <Tooltip>
        <TooltipText>
          This ad is displayed using third party content and we do not control its accessibility
          features.
        </TooltipText>
      </Tooltip>
    </TitleWrapper>
    <DesktopAd element={element} />
  </Wrapper>
)

export default RightRailContentfulAd
